import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import ButtonGrid from "./ButtonGrid.js";

export default function LoginModal (props)
{
    function handleHide (e)
    {
	props.hide();
    }

    function handleSubmit (e)
    {
	props.submit();
    }

    return (
	<Modal
	    show={props.show}
	    onHide={handleHide}
	    centered
	>
	    <Modal.Header>
		<Modal.Title>Déconnexion</Modal.Title>
	    </Modal.Header>

	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>
			<Button variant="outline-secondary" size="md" onClick={handleHide}>Annuler</Button>
		    </ButtonGrid.Left>
		    <ButtonGrid.Right>
			<Button variant="outline-primary" size="md" onClick={handleSubmit}>Se déconnecter</Button>
		    </ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
